import { Component, Input, OnInit } from '@angular/core';

import { Alertc } from 'app/models';
import { CarriagewayType } from 'app/models/enums';
import { CbmInputStyle } from 'app/shared/input/cbm-input-style';
import { enumValues } from 'app/shared/util/enumValues';

@Component({
  selector: 'vild',
  templateUrl: './vild.component.html',
  styleUrls: ['./vild.component.scss']
})
export class VildComponent implements OnInit {
  @Input() label: string;
  @Input() readonly: boolean;
  @Input() inputStyle: CbmInputStyle;
  @Input() alertc: Alertc;

  public carriagewayTypes: string[];

  constructor() {}

  ngOnInit(): void {
    this.carriagewayTypes = enumValues(CarriagewayType);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/vild/vild.component.ts